<template>
  <div class="home" :class="[layout]">
    <component :is="layout" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    web: () => import(/* webpackChunkName: "type.web" */ './Web'),
    terminal: () => import(/* webpackChunkName: "type.terminal" */ './Terminal'),
  },
  computed: {
    ...mapState(['layout']),
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100dvh;
}
</style>
